<p-card styleClass="very-compact-card p-3">
  <h3 class="m-0">Созданные задачи</h3>
  <div class="my-3">
    <crm-table
      *ngIf="projects?.length && !loading"
      [columns]="columns"
      [values]="projects"
      styleClass="p-datatable-sm">
      <ng-template
        #rowTemplate
        let-project="item">
        <tr *ngIf="toProject(project) as project">
          <td>
            <a *ngIf="project.name" crmConditionalRouterLink [crmRouterLink]="['/project/card/', project.id]">
              {{ project.name }}
            </a>
            <p
              *ngIf="!project.name"
              class="text-gray-600">
              <i class="pi pi-lock mr-2"></i>Нет доступа
            </p>
            <p-tag
              *ngIf="project.deleted"
              severity="danger"
              value="Удалена"
              styleClass="ml-2"></p-tag>
          </td>
          <td>
            <div
              *ngIf="project.name"
              class="text-sm text-400">
              {{ project.created | date: 'dd.MM.yyyy' }}
            </div>
          </td>
        </tr>
      </ng-template>
    </crm-table>

    <p
      *ngIf="!projects?.length && !loading"
      class="text-xl font-medium">
      Нет задач
    </p>

    <crm-spinner
      *ngIf="loading"
      top="mt-4"></crm-spinner>
  </div>

  <div class="flex">
    <a
      *ngIf="projects?.length && !loading"
      label="в список"
      class="p-button-round p-button-text p-button-sm p-button-info cursor-pointer -ml-3"
      icon="pi pi-external-link"
      (click)="directToProjectList.emit()"></a>
  </div>
</p-card>
